import React, { useState } from "react";
import { useParams } from "react-router-dom";
import ContextApi from "../../../HOC/ContextsAPI/ContextApi";
import Layout from "../../../HOC/layout/Layout";
import Billing from "../../Page/Billing";
import BillingForm from "../BillingForm/BillingForm";
import AddBooking from "../BookingSection/AddBooking";
import AddCustomers from "../AddCustomers/AddCustomers";
import MembershipsPlan from "../MembershipsPlan/MembershipsPlan";
function Products() {
  const [Id, setId] = useState("");
  const { id } = useParams();
  console.log("iddddd", id);
  let mod;
  switch (id) {
    case "create booking":
      mod = (
        <div className="bg-white ">
          <div className="mx-5 px-5 py-3 text-white text-xl my-6 bg-yellow-400 w-fit font-semibold">
            Add Booking
          </div>{" "}
          <AddBooking />
        </div>
      );
      break;
    case "memberships plan":
      mod = (
        <div className="">
          <div className=" capitalize mx-5 px-5 py-3 text-white text-xl my-6 bg-yellow-400 w-fit font-semibold">
            our Membership plans
          </div>
          <MembershipsPlan />
        </div>
      );
      break;
    case " add Customers":
      mod = (
        <div className="">
          <div className=" capitalize mx-5 px-5 py-3 text-white text-xl my-6 bg-yellow-400 w-fit font-semibold">
            add Customers
          </div>
          <AddCustomers />
        </div>
      );
      break;
    default:
      break;
  }
  return (
    <ContextApi>
      <div className=" ">
        <Layout>{mod}</Layout>
      </div>
    </ContextApi>
  );
}

export default Products;
